module.exports = __webpack_public_path__ + "img/logoDigiLab.7dbdc02f.png";